import { render, staticRenderFns } from "./help-joinus.vue?vue&type=template&id=b36a6bea&"
import script from "./help-joinus.vue?vue&type=script&lang=js&"
export * from "./help-joinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports